import Vue from 'vue';
import Vuex from 'vuex';
import { syncFrameHeight } from "./helpers";
import { last } from 'lodash';
import moment from "moment";

Vue.use(Vuex);

const strict = process.env.NODE_ENV !== 'production';

let paylineKey = `currentPayline.${Config.shop_id}.${Config.game_id}`;
let currentAmountKey = `currentAmount.${Config.shop_id}.${Config.game_id}.${Config.currency.code}`;
let skipIntroKey = `skipIntro.${Config.shop_id}.${Config.game_id}`;

let currentPayline = last(Config.paylines_available);

try {
    if(localStorage.getItem(paylineKey)) {
        const storagePayline = parseInt(localStorage.getItem(paylineKey));
    
        if(Config.paylines_available.includes(storagePayline)) {
            currentPayline = storagePayline;
        }
    }
    
    let localStorageAmount = localStorage.getItem(currentAmountKey);
    
    if(localStorageAmount) {
        localStorageAmount = JSON.parse(localStorageAmount);
        
        if(Config.amounts.some(e => e.id === localStorageAmount.id && e.amount === localStorageAmount.amount)) {
            Config.current_amount = localStorageAmount;
        }
    }
} catch(e) {

}

const state = {
    canvasReady: false,
    relayMethods: undefined,
    currentAmount: Config.current_amount,
    amounts: Config.amounts,
    currentPayline: currentPayline,
    autoSpins: 0,
    autoSpinsSettings: {
        stopOnWin: false,
    },
    reelSpinning: false,
    amountWon: 0,
    totalAmountWon: 0,
    balance: Config.balance,
    message: '',
    messageAdditional: undefined,
    afterMessage: undefined,
    freeSpins: undefined,
    currencySign: Config.currency.symbol,
    speed: false,
    mute: false,
    device: undefined,
    isLogged: Config.is_logged,
    mode: Config.mode,
    showControls: true,
    explanationVisible: false,
    explanationCallback: false,
    popGracefulPause: false,
    savedAutoSpins: 0,
    lifetimeAmount: Config.lifetime_amount,
    integrationGateway: undefined,
    cooldownGamingEnd: Config.cooldown_gaming_end,
    datetime: undefined,
};

const mutations = {
    setRelayMethods(state, relayMethods) {
        state.relayMethods = relayMethods;
    },
    setSavedAutoSpins(state, amount) {
      state.savedAutoSpins = amount;
    },
    updateCurrentAmount(state, amount) {
        state.relayMethods.clickEvent('updateCurrentAmount');
        Config.current_amount = amount;
        try{
            localStorage.setItem(currentAmountKey, JSON.stringify(Config.current_amount));
        } catch(e) {

        }
        state.currentAmount = Config.current_amount;
    },
    updateCurrentPayline(state, payline) {
        state.relayMethods.clickEvent('updateCurrentPayline');

        state.currentPayline = payline;
        try{
            localStorage.setItem(paylineKey, payline);
        } catch(e) {

        }
        state.relayMethods.showChosenPaylines();
    },
    setAutoSpin(state, autoSpins) {
        state.relayMethods.clickEvent('setAutoSpin');
        state.autoSpins = autoSpins;
        state.relayMethods.setAutoSpin();
    },
    setPopGracefulPause(state, status) {
        state.popGracefulPause = status;

        if (status === false && state.autoSpins !== 0) {
            this.commit('setAutoSpin', state.autoSpins);
        }
    },
    setAutoSpinSetting(state, { name, value }) {
        Vue.set(state.autoSpinsSettings, name, value);
    },
    setFreeSpins(state, freeSpins) {
        state.freeSpins = freeSpins;
    },
    reelSpinStatus(state, spinning) {
        state.reelSpinning = spinning;
    },
    showControls(state, show) {
        state.relayMethods.clickEvent('showControls');
        state.showControls = show;
    },
    setAmountWon(state, amountWon) {
        state.amountWon = amountWon;
    },
    setTotalAmountWon(state, totalAmountWon) {
        state.totalAmountWon = totalAmountWon;
    },
    setBalance(state, balance) {
        state.balance = balance;
    }, 
    setMessage(state, message) {
        state.message = message;
    },
    setAfterMessage(state, callback) {
        state.afterMessage = callback;
    },
    setMessageAdditional(state, opts) {
        state.messageAdditional = opts;
    },
    canvasReady(state) {
        state.canvasReady = true;
    },
    toggleSpeed(state) {
        state.relayMethods.clickEvent('toggleSpeed');
        state.speed = !state.speed;
        state.relayMethods.toggleSpeed(state.speed);
    },
    toggleMute(state) {
        state.relayMethods.clickEvent('toggleMute');
        state.mute = !state.mute;
        state.relayMethods.toggleMute(state.mute);
    },
    setDevice(state, device) {
        state.device = device;
    },
    logout(state) {
        console.log('logout')
        state.isLogged = false;
    },
    setConnectionStatus(state, status) {
        console.log(status)
        state.connectionStatus = status;
    },
    toggleExplanation(state, payload) {
        try {
            if(!Config.explanation_template || (!state.explanationVisible && localStorage.getItem(skipIntroKey))) {
                if(payload.callback) {
                    payload.callback();
                }
                return;
            }
        } catch(e) {
            console.log(e)
        }

        state.explanationVisible = !state.explanationVisible;

        if(!state.explanationVisible) {
            state.relayMethods.clickEvent('toggleExplanation');
        }

        state.explanationCallback = payload.callback;
        state.relayMethods.setExplanationStatus(state.explanationVisible);
        if(payload.dontShowIntro) {
            try {
                if(localStorage.setItem(skipIntroKey, 1)) {
                    return;
                }
            } catch(e) {
                console.log(e)
            }
        }
    },
    sendPurchase(state) {
        state.relayMethods.purchase();
    },
    updateLifetimeAmount(state, amount) {
        state.lifetimeAmount = amount;
    },
    setIntegrationGateway(state, gateway) {
        state.integrationGateway = gateway;
    },
    updateDatetime(state, datetime) {
        state.datetime = datetime;
    },
    incrementDatetime(state) {
        const datetime = moment(state.datetime).add(1, 'seconds');

        state.datetime = datetime.format('YYYY-MM-DD HH:mm:ss');
    },
    updateCooldownGamingEnd(state, datetime) {
        state.cooldownGamingEnd = datetime;
    },
};

const getters = {
    currentPayline() {
        return state.currentPayline;
    },
    autoSpins() {
        return state.autoSpins;
    },
    reelSpinning() {
        return state.reelSpinning;
    },
    popGracefulPause() {
        return state.popGracefulPause;
    },
    ticketInProgress() {
        return state.ticketInProgress;
    },
    savedAutoSpins() {
        return state.savedAutoSpins;
    }
};

const actions = {};

export default new Vuex.Store({ strict, state, mutations, getters, actions });